var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clickable-layer blink_me",attrs:{"id":_vm._uid + '-clickable-layer'},on:{"click":function($event){return _vm.adClicked()}}})}
var staticRenderFns = []

export { render, staticRenderFns }